import React, { PropTypes } from "react";
import _ from "lodash";
import moment from "moment";
import { connect } from "react-redux";
import { converDateIntoLocalwithmonth } from "Constants";
import Button from "react-bootstrap-button-loader";
import LocaleStrings from "Languages";
import Viewusagehistorymodal from "./usagehistorymodal-view";


class UsageHistoryitemlist extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            resetpassword: false,
            loading: false,
            allowingaccess: false,
            selectedUsers: [],
            showEmailPreviewModal: false,
        };
    }

    openModal = (section) => {
        this.setState({
            isOpen: true,
        });
    };
    closeModal = () => {
        this.setState({ isOpen: false });
    };


    exportBills = (data, ShowLabel) => {
        let arr = [];
        arr.push(data.userdata); //
        let JSONData = {};
        JSONData["usage_history"] = data.userdata;
        this.JSONToCSVConvertor(JSONData, ShowLabel);
    };

    JSONToCSVConvertor(JSONData, ShowLabel) {
        this.setState({ loading: true });
        var XLSX = require("xlsx");
        let wb = XLSX.utils.book_new();
        // console.log('wb',wb)
        _.map(JSONData, (item, index) => {
            /* Create a worksheet */
            var ws = XLSX.utils.json_to_sheet(item);
            // // var ws1 = XLSX.utils.json_to_sheet(JSONData['F2(149426)']);

            var sheetName = index.replace(/[\/\\:\[\]*?]/g, "_"); // Sheet name cannot contain ': \ / ? * [ ]' so replacing with '_' and also can not contain more than 31 chars
            if (sheetName.length > 30) {
                sheetName = sheetName.substr(0, 28) + "...";
            }

            XLSX.utils.book_append_sheet(wb, ws, sheetName);
            // XLSX.utils.book_append_sheet(wb, ws1, "F2(149426)");
        });
        XLSX.writeFile(wb, "usage_history.xlsx");
        this.setState({ loading: false });
    }

    render() {
        let { values, index } = this.props;

        let show = false;
        let firstdate = values.firstdate
            ? moment(values.firstdate, "YYYY-MM-DD")
            : null;

        let currentDate = moment();

        if (currentDate.isAfter(moment(firstdate))) {
            show = true;
        }
        let startdate = "";
        let enddate = "";
        startdate = converDateIntoLocalwithmonth(values.firstdate).format("D MMM YYYY");
        enddate = converDateIntoLocalwithmonth(values.lastdate).format("D MMM YYYY");
        return (
            <>
                {show == true ? (
                    <tr
                        key={index} id={index}
                    >
                        <td>
                            <div
                                className="row"
                                style={{ display: "flex", paddingLeft: 20, paddingTop: 3 }}
                            >
                                <div className="vcenter">{startdate} to {enddate}</div>
                            </div>
                        </td>
                        <td>
                            <div
                                className="row"
                                style={{ display: "flex", paddingLeft: 19, paddingTop: 3 }}
                            >
                                <div className="vcenter">
                                    {values.accountusage != 0 ? (<>-{values.accountusage}</>) : (0)}
                                </div>
                            </div>
                        </td>
                        <td>
                            <div
                                className=""
                                style={{ display: "flex", paddingLeft: 19, paddingTop: 3 }}
                            >
                                <Button
                                    className="btn-custom-blue schedule-add-button"
                                    onClick={() => this.openModal()}
                                // loading={this.state.loading}
                                >
                                    {LocaleStrings.accountsetting_usagehistory_table_btndetails}
                                </Button>
                                <Button
                                    className="btn-custom-blue schedule-add-button ml-5"
                                    onClick={() => this.exportBills(values)}
                                // loading={this.state.loading}
                                >
                                    {LocaleStrings.button_download}
                                </Button>
                                {this.state.isOpen ? (
                                    <Viewusagehistorymodal
                                        isOpen={this.state.isOpen}
                                        onClose={this.closeModal}
                                        data={values.userdata}
                                        firstdate={values.firstdate}
                                        lastdate={values.lastdate}
                                    />
                                ) : (
                                    ""
                                )}
                            </div>
                        </td>
                    </tr>
                ) : ('')}
            </>

        );
    }
}

export var mapStateToProps = (state) => {
    return {
        session: state.session,
    };
};

export default connect(mapStateToProps, {})(UsageHistoryitemlist);
